<template>
<div class="product-info">
    <div :class="{'bg-head-nav': true, 'bg-head-h187': isBgHeaderH187}"></div>
    <div class="area-1290 product-info-main">
        <div class="controller-container">
            <div class="controller-content">
                <el-select class="action-select-first" @change="getProductList(0, false)" v-model="oilClassIndex" placeholder="请选择油类">
                    <el-option v-for="(item, index) in oilClassArr" :key="index" :label="item.name" :value="index">
                    </el-option>
                </el-select>
                <el-select :class="{'action-select-inventory': true, 'hide': isHide}" @change="getProductList(0, true)" v-model="inventoryIndex" placeholder="请选择仓库">
                    <el-option v-for="(item, index) in inventoryArr" :key="index" :label="item.warehouse_name" :value="index">
                    </el-option>
                </el-select>
                <el-button v-if="userTypeNum == 2 && user.is_station_boss " type="primary" @click="changeRole" class="changeRole">切换为销售代表</el-button>
                <el-cascader @change="changeRole" :class="{'action-select-inventory': true, 'hide': !isSell}" placeholder="切换为门店角色..." :options="storeOption" filterable></el-cascader>
                <el-badge v-if="userTypeNum != 0" :value="cart.length" :max="99" class="add-purchase-order">
                    <div @click="purchaseOrder"></div>
                </el-badge>
            </div>
        </div>
        <div :class="{'goods-list':true, 'clearfix':true}">
            <el-card v-for="(item, index) in goodsArr" :key="index" class="goods-card-container " :body-style="{ padding: '0px' }">
                <div style="padding: 24px;">
                    <el-row class="product-pannel-top">
                        <el-col :span="10" class="product-img">
                            <img :src="item.picture" class="image" alt="">
                        </el-col>
                            <el-col :span="14">
                                <div class="proname-container">
                                    <p class="proname">{{item.name}}</p>
                                </div>
                            </el-col>
                    </el-row>
                    <el-row :class="{'product-pannel-control': true, 'hide': isHide}">
                        <el-col :span="12">
                            <el-input-number v-model="item.good_num" :step="1" :min="0"></el-input-number>
                        </el-col>
                        <el-col :span="9" :offset="2">
                            <el-button type="success" round @click="addPurchaseOrder(item)">加入进货单</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
        </div>
    </div>
</div>
</template>

<script>
import Cookie from 'js-cookie';
import {
    mapGetters,
    mapMutations,
    mapActions
} from 'vuex';
export default {
    data() {
        return {
            isHide: true,
            isSell: false,
            isBgHeaderH187: true,
            inventoryIndex: 0,
            inventoryArr: [],
            oilClassIndex: 0,
            oilClassArr: [],
            goodsArr: [],
            storeOption: [],
            // 分页
            // message: Data.artDetail,
            pullRefreshss: true,
            page: 2,
            scollY: null,
            pageTotal: 7
        }
    },
    computed: {
        ...mapGetters(['userTypeNum', 'user', 'newAddGoodsNum', 'cart'])
    },
    created() {
        if (this.userTypeNum != 0) {
            this.isHide = false;
            this.isSell = false;
        }
        else {
            if(this.user.role.role_num == 0) {
                this.isSell = true;
                this.axios.get('selleruser_store', {
                    params: {
                        selleruser_id: this.user.id
                    }
                })
                .then(res => {
                    this.storeOption = res.data.data;
                })
            }
        }
        this.init();
    },
    methods: {
        // ...mapMutations(['initUser', 'setUserTypeNum', 'setPlayer']),
        ...mapMutations(['setNewAddGoodsNum', 'initCart','initUser', 'setUserTypeNum']),
        ...mapActions(['addGoods']),
        init() {
            if (this.userTypeNum != 0) {
                this.axios.get('getwarehouse', {
                        params: {
                            user_id: this.user.id,
                            type: 2
                        }
                    })
                    .then(res => {
                        this.inventoryArr = res.data.data;
                        this.axios.get('get_classification')
                            .then(res => {
                                this.oilClassArr = res.data.data;
                                this.getProductList(1, true, res => {
                                    this.initPurchaseOrder()
                                });
                            })
                    })
            } else {
                this.axios.get('getwarehouse', {
                        params: {
                            user_id: this.user.id,
                            type: 1
                        }
                    })
                    .then(res => {
                        this.inventoryArr = res.data.data;
                        this.axios.get('get_classification')
                            .then(res => {
                                this.oilClassArr = res.data.data;
                                this.getProductList(1, true);
                            })
                    })
            }
            this.pullRefresh();
        },
        //文档的总高度
        getScrollTop: function () {
            var scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0;
            if (document.body) {
                bodyScrollTop = document.body.scrollTop;
            }
            if (document.documentElement) {
                documentScrollTop = document.documentElement.scrollTop;
            }
            scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
            return scrollTop;
        },
        //浏览器视口的高度
        getScrollHeight: function () {
            var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
            if (document.body) {
                bodyScrollHeight = document.body.scrollHeight;
            }
            if (document.documentElement) {
                documentScrollHeight = document.documentElement.scrollHeight;
            }
            scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
            return scrollHeight;
        },
        //浏览器视口的高度
        getWindowHeight: function () {
            var windowHeight = 0;
            if (document.compatMode == "CSS1Compat") {
                windowHeight = document.documentElement.clientHeight;
            } else {
                windowHeight = document.body.clientHeight;
            }
            return windowHeight;
        },
        // 下拉加载ajax
        pullRefresh: function () {
            var _this = this;
            window.onscroll = function () {
                _this.scrollChange()
            }
        },
        scrollChange: function () {
            var _this = this,
                currentPage = {page: this.page};
            /**
             * @getScrollTop: 返回距离实际顶部边缘的距离
             * @getWindowHeight: 返回整个浏览器窗口的高度
             * @getScrollHeight: 返回文档元素的高度
             */    
            this.scollY = this.getScrollTop() + this.getWindowHeight() - this.getScrollHeight();
            console.log('scollY: ', this.scollY);
            // 把下拉刷新置为false，防止多次请求
            if (this.scollY >= -50) {
                if (this.page > this.pageTotal) {
                    return false;
                }
                if (!this.pullRefreshss) {
                    return false;
                }
                // 模拟ajax请求
                // setTimeout(function () {
                //     axios.get('http://test.com', {
                //         params: currentPage
                //     }).then(function (res) {
                //         // 请求完成后，把得到的数据拼接到当前dom里面
                //         _this.message = _this.message.concat(res.data.artDetail);
                //         console.log('scrollHeight:', document.documentElement.scrollHeight);
                //     }).catch(function (err) {
                //         console.log(err)
                //     })
                // }, 2000)
                _this.getProductList(this.page, false);
                _this.pullRefreshss = false;
                // 加页码数
                this.page++;
            } else {
                // 其他时候把下拉刷新置为true
                console.log('下拉刷新置为true')
                _this.pullRefreshss = true;
            }
        },
        // 切换角色
        changeRole(roleId) {
            console.log('roleId: ', roleId);
            let role = {};
            if(this.userTypeNum == 2) {
                role.account = this.user.high_seller.account;
                role.password = this.user.high_seller.password;
            } 
            else if(this.userTypeNum == 0) {
                let province = {};
                let city = {};
                for(let i = 0, len = this.storeOption.length; i < len; i++) {
                    if(this.storeOption[i].value == roleId[0]) {
                        province = this.storeOption[i].children;
                        console.log('province: ', province)
                        break;
                    }
                }
                for(let i = 0, len = province.length; i < len; i++) {
                    if(province[i].value == roleId[1]) {
                        city = province[i].children;
                        console.log('city: ', city)
                        break;
                    }
                }
                for(let i = 0, len = city.length; i < len; i++) {
                    if(city[i].value == roleId[2]) {
                        role = city[i];
                        console.log('role: ', role)
                        break;
                    }
                }
            }
            console.log('role: ', role);
            Cookie.remove('xian-spl-token')
            this.axios.get('/login', {
                params: {
                    account: role.account,
                    password: role.password
                }
            }).then(res => {
                console.log('login again: ', res.data);
                var shortName = this.$Tool.getShortText(res.data.data.name, 3);
                this.$set(res.data.data, 'shortName', shortName);
                this.initUser(res.data.data);
                this.setUserTypeNum(res.data.data.user_type.user_type_num);
                Cookie.set('xian-spl-token', res.data.data.spl_token, {
                    expires: 7,
                    path: '/'
                });
                this.$router.push({
                    name: 'reloadcurrent',
                    query: {
                        page: 'productinfo'
                    }
                })
            })
        },
        // 初始化购物车
        initPurchaseOrder(cb) {
            if (this.userTypeNum == 2) {
                if (this.user.role.role_num == 1) {
                    var style = 1;
                } else {
                    var style = 0;
                }
            } else {
                var style = 0;
            }
            this.axios.get('shopping_cart', {
                    params: {
                        style: style,
                        user_id: this.user.id,
                        warehouse_id: this.inventoryArr[this.inventoryIndex].warehouse_id
                    }
                })
                .then(res => {
                    this.initCart(res.data.data);
                    if(cb != 'function') {
                        cb();
                    }
                })
        },
        // 请求商品列表
        getProductList(pageNum, isInitCart, callback) {
            if(pageNum == 0) {
                this.page = 2;
                this.goodsArr.splice(0, this.goodsArr.length);
                pageNum = 1;
            }
            this.axios.get('obtain_warehouse_info', {
                    params: {
                        class_id: this.oilClassArr[this.oilClassIndex].id,
                        warehouse_id: this.inventoryArr[this.inventoryIndex].warehouse_id,
                        page_num: pageNum,
                        page_size: 18
                    }
                })
                .then(res => {
                    this.pageTotal = res.data.page_sum;
                    if(res.data.data.length > 0) {
                        res.data.data.forEach(item => {
                            item.good_num = parseFloat('0');
                            item.isChecked = false;
                        });
                        this.goodsArr =  this.goodsArr.concat(res.data.data) ;

                        if ((typeof callback) == 'function') {
                            callback();
                        } else if (isInitCart) {
                            this.initPurchaseOrder();
                        }
                    }
                    else {
                        this.$message({
                            type: 'warning',
                            message: '暂无数据！'
                        });
                    }
                })
        },
        // 加入进货单
        addPurchaseOrder(item) {
            if (this.userTypeNum == 2) {
                if (this.user.role.role_num == 1) {
                    var style = 1;
                } else {
                    var style = 0;
                }
            } else {
                var style = 0;
            }
            if(item.good_num == 0) {
                this.$message({
                    type: 'warning',
                    message: '无法加入进货单！'
                });
                return;
            }
            var cartParams = {
                style: style,
                user_id: this.user.id,
                warehouse_id: this.inventoryArr[this.inventoryIndex].warehouse_id,
                goods: item,
                callback: this.$message
            }
            this.addGoods(cartParams);
            this.$set(item, 'good_num', 0);
        },
        // 进入进货单页面
        purchaseOrder() {
            this.$router.push({
                'name': 'mypurchaseorder'
            });
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.product-info-main {
    position: relative;
    top: -169px;
    background-color: transparent;
}

.action-select-first,
.action-select-inventory {
    margin-left: 24px;
    width: 161px;
}

.changeRole {
    margin-left: 24px;
}

.action-select-first {
    margin-left: 0px;
}

.bg-head-nav {
    background-color: #d2f5e8;
    height: 133px;
}

.bg-head-h187 {
    height: 187px;
}

.goods-card-container {
    float: left;
    width: 400px;
    margin-right: 27px;
    margin-bottom: 20px;
    border-radius: 8px;
}

.product-pannel-top {
    height: 161px;
}

.image {
    width: 100%;
    display: block;
}

.proname {
    font-size: 18px;
    color: #242424;
    font-weight: 700;
}

.el-input-number {
    width: 80%;
}

.add-purchase-order {
    position: absolute;
    right: 15px;
    top: -47px;
}

.add-purchase-order>div {
    width: 88px;
    height: 24px;
    background-image: url(../../assets/imgs/purchaselist.png);
    background-size: 100% 100%;
    cursor: pointer;
}
.product-img {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderManage/ProductInfo.vue